<template>
  <div>
    <div class="stickfooter">
      <div class="container lg text-center">
        <router-link to="/" tag="div" class="col-xs-3 pointer">
          <span class="fad fa-2x"
            ><img src="@/assets/logo.svg" class="stick-logo"
          /></span>
          <p>
            {{ $t("Home") }}
          </p>
        </router-link>
        <router-link to="/market" tag="div" class="col-xs-3 pointer">
          <span class="fad fa-analytics fa-2x"></span>
          <p>
            {{ $t("Market") }}
          </p>
        </router-link>
        <router-link
          v-bind:to="'/' + getSitemode + '/' + getPair"
          tag="div"
          class="col-xs-3 pointer"
        >
          <span class="fad fa-coins fa-2x"></span>
          <p>
            {{ $t("Trade") }}
          </p>
        </router-link>

        <router-link to="/staking" tag="div" class="col-xs-3 pointer">
          <span class="fad fa-gift fa-2x"></span>
          <p>
            {{ $t("Earn") }}
          </p>
        </router-link>

        <router-link to="/balance" tag="div" class="col-xs-3 pointer">
          <span class="fad fa-wallet fa-2x"></span>
          <p>
            {{ $t("Funds") }}
          </p>
        </router-link>

        <router-link to="/setting" tag="div" class="col-xs-3 pointer">
          <span class="fad fa-user-astronaut fa-2x"></span>
          <p>
            {{ $t("Account") }}
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getPair", "getSitemode"])
  },
  methods: {},
  updated() {}
};
</script>

<style scoped>
.container {
  padding-right: 0px;
  padding-left: 0px;
}
/* stickfooter */
.stickfooter {
  position: fixed;
  padding-top: 0px;
  padding-bottom: 65px;
  bottom: -1px;
  width: 100%;
  height: 76px;
  background-color: #282d33;
  z-index: 10;
}
.stickfooter span {
  margin-top: 3px;
}
.stickfooter p {
  font-size: 13px;
  margin-top: -4px;
}
.stickfooter .fa-2x {
  font-size: 1.5em;
  margin-bottom: 5px;
}
.stickfooter .col-xs-3 {
  width: 16.6666667%;
  padding: 0px;
  padding-top: 5px;
}
.stickfooter a {
  filter: invert(50%);
  color: #6f7481;
}
.stickfooter .router-link-exact-active {
  filter: invert(0%);
  color: #f6a821;
  border-top-color: #f6a821;
  border-top: solid;
  padding-top: 2px;
}
.stickfooter .stick-logo {
  height: 19px;
}
</style>
